export default __webpack_public_path__ + "static/media/c008-1.cd3d514c.png";